export const LOAN_APP_SUBMISSION_METHODS = {
  NEXT_GEN: 'nextgen',
  SIMPOLOGY: 'simpology',
  EMAIL: 'email',
  PRINT: 'print',
};
